import React from "react";
import MatchComparisonProgressBar from "./MatchComparisonProgressBar.js";
import classes from "./MatchStats.module.css";
import { useTranslation } from "react-i18next";

const MatchStats = ({ teamStatistics }) => {

    const { t } = useTranslation();

    return (
        <div className={classes.stats_container}>
            <div className={classes.teams_info}>
                <div className={classes.home_team_container}>
                    <img
                        src={teamStatistics?.homeTeamLogo}
                        className={classes.team_logo}
                        alt={teamStatistics?.homeTeamName}
                    />
                    <p className={classes.name}>
                        {teamStatistics?.homeTeamName}
                    </p>
                </div>
                <div className={classes.away_team_container}>
                    <img
                        src={teamStatistics?.awayTeamLogo}
                        className={classes.team_logo}
                        alt={teamStatistics?.awayTeamName}
                    />
                    <p className={classes.name}>
                        {teamStatistics?.awayTeamName}
                    </p>
                </div>
            </div>
            <div className={classes.stats_sub_container}>
                <MatchComparisonProgressBar
                    percentage1={teamStatistics?.homeTeamTotalShotsPer}
                    percentage2={teamStatistics?.awayTeamTotalShotsPer}
                    value1={
                        teamStatistics?.homeTeamTotalShots != null
                            ? teamStatistics?.homeTeamTotalShots
                            : 0
                    }
                    value2={
                        teamStatistics?.awayTeamTotalShots != null
                            ? teamStatistics?.awayTeamTotalShots
                            : 0
                    }
                    name={
                        t("148")
                    }
                />
                <MatchComparisonProgressBar
                    percentage1={teamStatistics?.homeTeamShotsOnGoalPer}
                    percentage2={teamStatistics?.awayTeamShotsOnGoalPer}
                    value1={
                        teamStatistics?.homeTeamShotsOnGoal != null
                            ? teamStatistics?.homeTeamShotsOnGoal
                            : 0
                    }
                    value2={
                        teamStatistics?.awayTeamShotsOnGoal != null
                            ? teamStatistics?.awayTeamShotsOnGoal
                            : 0
                    }
                    name={
                        t("149")

                    }
                />
                <MatchComparisonProgressBar
                    percentage1={teamStatistics?.homeTeamShotsOffGoalPer}
                    percentage2={teamStatistics?.awayTeamShotsOffGoalPer}
                    value1={
                        teamStatistics?.homeTeamShotsOffGoal != null
                            ? teamStatistics?.homeTeamShotsOffGoal
                            : 0
                    }
                    value2={
                        teamStatistics?.awayTeamShotsOffGoal != null
                            ? teamStatistics?.awayTeamShotsOffGoal
                            : 0
                    }
                    name={
                        t("150")

                    }
                />
                <MatchComparisonProgressBar
                    percentage1={teamStatistics?.homeTeamFoulsPer}
                    percentage2={teamStatistics?.awayTeamFoulsPer}
                    value1={
                        teamStatistics?.homeTeamFouls != null
                            ? teamStatistics?.homeTeamFouls
                            : 0
                    }
                    value2={
                        teamStatistics?.awayTeamFouls != null
                            ? teamStatistics?.awayTeamFouls
                            : 0
                    }
                    name={
                        t("151")

                    }
                />
                <MatchComparisonProgressBar
                    percentage1={teamStatistics?.homeTeamCornerPer}
                    percentage2={teamStatistics?.awayTeamCornerPer}
                    value1={
                        teamStatistics?.homeTeamCorner != null
                            ? teamStatistics?.homeTeamCorner
                            : 0
                    }
                    value2={
                        teamStatistics?.awayTeamCorner != null
                            ? teamStatistics?.awayTeamCorner
                            : 0
                    }
                    name={
                        t("152")

                    }
                />
                <MatchComparisonProgressBar
                    percentage1={teamStatistics?.homeTeamOffsidesPer}
                    percentage2={teamStatistics?.awayTeamOffsidesPer}
                    value1={
                        teamStatistics?.homeTeamOffsides != null
                            ? teamStatistics?.homeTeamOffsides
                            : 0
                    }
                    value2={
                        teamStatistics?.awayTeamOffsides != null
                            ? teamStatistics?.awayTeamOffsides
                            : 0
                    }
                    name={
                        t("153")

                    }
                />

                <MatchComparisonProgressBar
                    percentage1={teamStatistics?.homeTeamYellowCardPer}
                    percentage2={teamStatistics?.awayTeamYellowCardPer}
                    value1={
                        teamStatistics?.homeTeamYellowCard != null
                            ? teamStatistics?.homeTeamYellowCard
                            : 0
                    }
                    value2={
                        teamStatistics?.awayTeamYellowCard != null
                            ? teamStatistics?.awayTeamYellowCard
                            : 0
                    }
                    name={
                        t("154")

                    }
                />
                <MatchComparisonProgressBar
                    percentage1={teamStatistics?.homeTeamRedCardPer}
                    percentage2={teamStatistics?.awayTeamRedCardPer}
                    value1={
                        teamStatistics?.homeTeamRedCard != null
                            ? teamStatistics?.homeTeamRedCard
                            : 0
                    }
                    value2={
                        teamStatistics?.awayTeamRedCard != null
                            ? teamStatistics?.awayTeamRedCard
                            : 0
                    }
                    name={
                        t("155")

                    }
                />
                <MatchComparisonProgressBar
                    percentage1={teamStatistics?.homeTeamPossession.replace("%", "")}
                    percentage2={teamStatistics?.awayTeamPossession.replace("%", "")}
                    value1={
                        teamStatistics?.homeTeamPossession != null
                            ? teamStatistics?.homeTeamPossession
                            : 0
                    }
                    value2={
                        teamStatistics?.awayTeamPossession != null
                            ? teamStatistics?.awayTeamPossession
                            : 0
                    }
                    name={
                        t("156")

                    }
                />
                <MatchComparisonProgressBar
                    percentage1={teamStatistics?.homeTeamPassesPer}
                    percentage2={teamStatistics?.awayTeamPassesPer}
                    value1={
                        teamStatistics?.homeTeamPasses != null
                            ? teamStatistics?.homeTeamPasses
                            : 0
                    }
                    value2={
                        teamStatistics?.awayTeamPasses != null
                            ? teamStatistics?.awayTeamPasses
                            : 0
                    }
                    name={
                        t("157")
                    }
                />
            </div>
        </div>
    );
};

export default MatchStats;
